import React from 'react';
import { common } from '@kurtosys/ksys-app-template';

import { IDropdownAssets, IDropdownItem } from '../../Dropdown/models/index.js';
import { ITranslationContextValue } from '../../Translate/models/ITranslationContextValue.js';
import PageSelector from '../styledComponents/PageSelector.js';
import PageSelectorPrefix from '../styledComponents/PageSelectorPrefix.js';
import PageSelectorSuffix from '../styledComponents/PageSelectorSuffix.js';
import PageSelectorWrapper from '../styledComponents/PageSelectorWrapper.js';

interface PageSelectionProps {
	currentPage: number;
	pageOptions: { label: string; value: string }[];
	ariaControls?: string;
	placeholders: any;
	pageSelection?: {
		enabled?: boolean;
		prefix?: string;
		suffix?: string;
		ariaLabel?: string;
	};
	handlePageChange: (item: IDropdownItem | IDropdownItem[], index?: number) => void;
	translationContext?: ITranslationContextValue;
	dropdownAssets?: IDropdownAssets;
}

function translate(
	translationContext?: ITranslationContextValue,
	text?: string,
	placeholders: Record<string, any> = {},
) {
	if (text) {
		return translationContext
			? translationContext.translate(text, placeholders)
			: common.commonUtils.replacePlaceholders({ values: placeholders, text });
	}
}

export const PageSelection: React.FC<PageSelectionProps> = ({
	currentPage,
	pageOptions,
	ariaControls,
	placeholders,
	pageSelection,
	handlePageChange,
	translationContext,
	dropdownAssets,
}) => {
	if (pageSelection && pageSelection.enabled) {
		const { prefix, suffix } = pageSelection;
		const pageSelectionAriaLabel = pageSelection?.ariaLabel ?? 'Page {currentPage} of {totalPages}';
		const ariaLabel = translate(translationContext, pageSelectionAriaLabel, placeholders);
		const pageSelectionPrefix = translate(translationContext, prefix, placeholders);
		const pageSelectionSuffix = translate(translationContext, suffix, placeholders);

		return (
			<PageSelectorWrapper aria-label={ariaLabel}>
				{prefix && <PageSelectorPrefix aria-hidden="true">{pageSelectionPrefix}</PageSelectorPrefix>}
				<PageSelector
					onChange={handlePageChange}
					selectedItem={pageOptions.find((option) => option.value === currentPage.toString())}
					items={pageOptions}
					ariaControls={ariaControls}
					dropdownAssets={dropdownAssets}
				/>
				{suffix && <PageSelectorSuffix aria-hidden="true">{pageSelectionSuffix}</PageSelectorSuffix>}
			</PageSelectorWrapper>
		);
	}
	return null;
};
